class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;
    
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (!summary) return;
    
    this.content = summary.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    if (!this.mainDetailsToggle) return;
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.mainDetailsToggle || !this.content) return;
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (!summary) return;
    
    this.mainDetailsToggle.removeAttribute('open');
    summary.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    // Bind methods for event listeners
    this.updateHeaderBottomPosition = this.updateHeaderBottomPosition.bind(this);
  }

  connectedCallback() {
    // Ensure header is found
    if (!this.header) {
      this.header = document.querySelector('.header-wrapper');
    }
    // Set initial value and update on resize/scroll
    // Use requestAnimationFrame to ensure DOM is fully ready
    requestAnimationFrame(() => {
      this.updateHeaderBottomPosition();
    });
    window.addEventListener('resize', this.updateHeaderBottomPosition);
    window.addEventListener('scroll', this.updateHeaderBottomPosition);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updateHeaderBottomPosition);
    window.removeEventListener('scroll', this.updateHeaderBottomPosition);
  }

  updateHeaderBottomPosition() {
    if (!this.header) return;
    // Only update on desktop (min-width: 1025px)
    if (window.innerWidth >= 1025) {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }

  onToggle() {
    if (!this.header || !this.mainDetailsToggle) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    // Update the position when menu toggles (header might have changed)
    this.updateHeaderBottomPosition();
  }
}

customElements.define('header-menu', HeaderMenu);
